import { observable } from "@legendapp/state";
import { listAgencies } from "@/apis/clients/agenciesClient";
import { toErrorMessage } from "@/stores/storeHelpers";
import type { Agency } from "@/types/agency";
import { sortByName } from "@/utils/sortOptions";

interface AgenciesState {
  agencies: Agency[];
  agencyInitialized: boolean;
  isLoading: boolean;
  error: string | null;
  loadedForOrganizationId: number | null;
}

const defaultValues: AgenciesState = {
  agencies: [],
  agencyInitialized: false,
  isLoading: false,
  error: null,
  loadedForOrganizationId: null,
};

export const AgenciesStore$ = observable(defaultValues);

export const fetchAgencies = async (organizationId: number) => {
  if (
    AgenciesStore$.isLoading.get() ||
    AgenciesStore$.loadedForOrganizationId.get() === organizationId
  ) {
    return;
  }

  AgenciesStore$.assign({ isLoading: true, error: null });

  try {
    const agencies = sortByName(await listAgencies(organizationId));
    AgenciesStore$.assign({
      agencies,
      loadedForOrganizationId: organizationId,
    });
  } catch (error) {
    AgenciesStore$.error.set(toErrorMessage(error));
  } finally {
    AgenciesStore$.isLoading.set(false);
  }
};

export const clearAgencies = () => {
  AgenciesStore$.assign({
    agencies: [],
    agencyInitialized: false,
    error: null,
    isLoading: false,
    loadedForOrganizationId: null,
  });
};
